import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/subsproduct`;
const planbaseUrl = `${process.env.REACT_APP_API_URL}/plans`;
export const planService = {
    getAllForActiveSubscriptionData,
    cancelUrl,
    getPlanWithFeatures,
};

function getPlanWithFeatures() {
    const url = `${planbaseUrl}`;
    return fetchWrapper.get(url);
}


function getAllForActiveSubscriptionData() {
    const url = `${baseUrl}`;
    return fetchWrapper.get(url);
}
function cancelUrl(cancelUrl) {


    const url = cancelUrl
    return fetchWrapper.get(url);
}





